// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_1Bq_S","dangerous":"view-default_dangerous_2vILS","iframe":"view-default_iframe_l0Ejt"};